//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import InputTag from "../../../../components/Form/InputTag";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { getDirection } from "../../../../utils";
export default {
  components: {
    'input-tag': InputTag,
    'v-select': vSelect
  },
  data: function data() {
    return {
      name: '',
      age: 0,
      basicForm: {
        email: '',
        password: '',
        checked: false
      },
      horizontalForm: {
        email: '',
        password: '',
        radio: '',
        checked: false
      },
      topLabelsOverLineForm: {
        email: '',
        password: '',
        tags: [],
        date: null,
        select: '',
        checked: false
      },
      topLabelsInInputForm: {
        email: '',
        password: '',
        tags: [],
        date: null,
        select: '',
        checked: false
      },
      gridForm: {
        email: '',
        password: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: ''
      },
      inlineForm: {
        fullname: '',
        lastname: '',
        checked: false
      },
      direction: getDirection().direction,
      horizontalFormRadios: [this.$t('forms.first-radio'), this.$t('forms.second-radio'), {
        text: this.$t('forms.third-radio-disabled'),
        disabled: true
      }],
      selectData: [{
        label: 'Chocolate',
        value: 'chocolate'
      }, {
        label: 'Vanilla',
        value: 'vanilla'
      }, {
        label: 'Strawberry',
        value: 'strawberry'
      }, {
        label: 'Caramel',
        value: 'caramel'
      }, {
        label: 'Cookies and Cream',
        value: 'cookiescream'
      }, {
        label: 'Peppermint',
        value: 'peppermint'
      }],
      stateOptions: ['', 'Option1', 'Option2', 'Option3', 'Option4', 'Option5']
    };
  },
  methods: {
    onBasicSubmit: function onBasicSubmit() {
      console.log(JSON.stringify(this.basicForm));
    },
    onHorizontalSubmit: function onHorizontalSubmit() {
      console.log(JSON.stringify(this.horizontalForm));
    },
    onTopLabelsOverLineFormSubmit: function onTopLabelsOverLineFormSubmit() {
      console.log(JSON.stringify(this.topLabelsOverLineForm));
    },
    onTopLabelsInInputFormSubmit: function onTopLabelsInInputFormSubmit() {
      console.log(JSON.stringify(this.topLabelsInInputForm));
    },
    onGridFormSubmit: function onGridFormSubmit() {
      console.log(JSON.stringify(this.gridForm));
    },
    onInlineSubmit: function onInlineSubmit() {
      console.log(JSON.stringify(this.inlineForm));
    }
  }
};